<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 563 145" role="img">
    <title lang="nl">Ontdek</title>
    <g>
      <path
        fill="currentColor"
        d="M53.2,2.8c28.8,0,52.2,23.8,52.2,53.1c0,16.3-7.2,30.8-18.5,40.6l32.5,40.5c1.5,1.9,1.2,4.6-0.7,6.1
        c-1.9,1.5-4.7,1.2-6.2-0.7l-32.7-40.8c-7.8,4.7-16.8,7.3-26.5,7.3C24.4,108.9,1,85.2,1,55.9C1,26.6,24.4,2.8,53.2,2.8z M129.9,1
        l69.6,84.3v-80h8.4v103.7l-69.6-84.4V106h-8.4V1z M292.8,5.2v8.6h-27.1V106h-8.9V13.8h-27.1V5.2H292.8z M329.8,5.2
        c4.2,0,8.2,0,12,0.1c3.8,0,7.3,0.3,10.7,0.7c3.3,0.4,6.5,1.1,9.4,2c2.9,0.9,5.7,2.2,8.4,3.9c6.4,4,11.4,9.8,14.9,17.3
        c3.5,7.5,5.3,16.3,5.3,26.5c0,9.2-1.4,17.3-4.3,24.2c-2.9,7-7,12.5-12.3,16.8c-2.8,2.3-5.8,4-8.8,5.2c-3,1.2-6.2,2.1-9.5,2.7
        c-3.3,0.6-6.7,1-10.3,1.1c-3.6,0.1-7.3,0.2-11.3,0.2h-19.4V5.2H329.8z M466,5.2v8.6h-39.8v31.6H466V54h-39.8v43.4H466v8.6h-48.7
        V5.2H466z M503.7,5.2v47.2l44.4-47.2h11.7l-46.6,48.2L562,106h-12.9l-45.4-51.1V106h-8.9V5.2H503.7z M53.2,11.7
        c-24,0-43.4,19.8-43.4,44.2c0,24.4,19.4,44.2,43.4,44.2s43.4-19.8,43.4-44.2C96.6,31.5,77.1,11.7,53.2,11.7z M334,12.8h-10.6v85.2
        h13.2c6.2,0,11.8-0.3,16.6-0.8c4.8-0.6,9.1-2.2,12.9-4.9c4.7-3.5,8.3-8.3,10.9-14.6c2.6-6.2,3.9-13.6,3.9-22.2
        c0-7-0.9-13.1-2.6-18.5c-1.7-5.4-4.2-9.9-7.4-13.6c-2.3-2.5-4.7-4.5-7.3-6c-2.6-1.5-5.4-2.5-8.4-3.2c-3-0.7-6.3-1.1-9.8-1.2
        C342,12.9,338.2,12.8,334,12.8z M53.6,83.7c2.1,0,4.3,0.2,6.1,0.7v1.4c-1.9,0.5-4,0.7-6.1,0.7c-2.1,0-4.3-0.2-6.1-0.7v-1.4
        C49.3,83.9,51.5,83.7,53.6,83.7z M55,24.4v46.7c6.5-0.4,12.5-2.6,13.2-8.1c1.2-9.4-6.5-17-5.8-26.3c0.2-2.7,1-5,3-7.1h3.4v2.2
        c-2.7,0.8-4.4,2.6-4.1,6.4c0.4,4.3,2.9,8.1,4.8,12.1c1.9,4.1,3.7,9,3.4,13.7c-0.6,9.2-8.1,12.1-17.8,12.8v3.4h-2v-3.4
        c-9.7-0.7-17.2-3.7-17.8-12.8c-0.3-4.7,1.5-9.5,3.4-13.7c1.9-4.1,4.4-7.8,4.8-12.1c0.3-3.9-1.4-5.6-4.1-6.4v-2.2h3.4
        c1.9,2.1,2.8,4.4,3,7.1c0.7,9.4-7,17-5.8,26.3c0.7,5.6,6.7,7.7,13.2,8.1V24.4H55z M51.8,29.8v36h-2.6v-36H51.8z M58.9,29.3v36h-2.6
        v-36H58.9z"
      />
    </g>
  </svg>
</template>
